import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faBox, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { formatNumber } from '../../../../../utils/numberFormatter';

const ProductForm = ({
  productName = '',
  productDescription = '',
  productNameConfig = 'required',
  productDescriptionConfig = 'optional',
  onProductNameChange,
  onProductDescriptionChange,
  amount = '',
  displayAmount = '',
  onAmountChange,
  onCalculatePlans,
  maxAmountState = 0,
  clientAuthorization = null,
  authorizationsEnabled = false,
  onRequestMoreCredit,
  lastCalculatedAmount = ''
}) => {
  const handleInputKeyPress = (e) => {
    if (e.key === 'Enter') {
      onCalculatePlans();
    }
  };

  return (
    <div className="col-md-8">
      {/* Campo de nombre del producto - Solo se muestra si no está oculto */}
      {productNameConfig !== 'hidden' && (
        <div className="form-group mb-3">
          <div className="input-group">
            <span className="input-group-text">
              <FontAwesomeIcon icon={faBox} />
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Nombre del producto (ej.: Heladera Samsung)"
              value={productName}
              onChange={(e) => onProductNameChange(e.target.value)}
              required={productNameConfig === 'required'}
            />
          </div>
        </div>
      )}

      {/* Campo de descripción del producto - Solo se muestra si no está oculto */}
      {productDescriptionConfig !== 'hidden' && (
        <div className="form-group mb-3">
          <div className="input-group">
            <span className="input-group-text">
              <FontAwesomeIcon icon={faFileAlt} />
            </span>
            <input
              type="text"
              className="form-control"
              placeholder={`Descripción ${productDescriptionConfig === 'required' ? '(requerido)' : '(opcional)'}`}
              value={productDescription}
              onChange={(e) => onProductDescriptionChange(e.target.value)}
              required={productDescriptionConfig === 'required'}
            />
          </div>
        </div>
      )}

      {/* Input de monto */}
      <div className="input-group">
        <span className="input-group-text">
          <FontAwesomeIcon icon={faDollarSign} />
        </span>
        <input
          type="text"
          className="form-control"
          id="amount"
          name="amount"
          autoComplete="off"
          placeholder="¿Cuál es el precio?"
          required
          value={displayAmount}
          onChange={onAmountChange}
          onKeyPress={handleInputKeyPress}
        />
        <button 
          className="btn btn-primary" 
          type="button" 
          onClick={onCalculatePlans}
          disabled={amount === lastCalculatedAmount || !amount}
        >
          Calcular Cuotas
        </button>
      </div>
      <p>
        <small className="text-muted">
          {`Monto máximo ${clientAuthorization?.status === 'approved' ? 'autorizado' : 'disponible'}: $${formatNumber(maxAmountState)}.`}
          {authorizationsEnabled && (
            <a href="#" onClick={onRequestMoreCredit}>
              {' '}Solicitar más cupo
            </a>
          )}
        </small>
      </p>
    </div>
  );
};

export default ProductForm;
